export const templateOfImageTextLeftBlock = `
    <div class="row content-block">
        <div class="col-12 col-sm-6 column px-8 py-4">
            <h4>Title</h4>
            <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
            </p>
        </div>
        <column-separator></column-separator>
        <div class="col-12 col-sm-6 column px-8 py-4">
            <img class="custom-image large" src="/assets/editor_images/sample_image_3.jpg" />
        </div>
    </div>
`
